import { useField } from "formik";

import RadioGroupNodeType from "../../types/RadioGroupNodeType";
import Radio from "@mui/material/Radio";
import MuiRadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import normalizeOptions from "./normalizeOptions";
import renderChildren from "../renderChildren";

export const RadioGroup =
    ({ name, options = [], inline, row, gap, sx, itemSx, labelSx, node, context }: RadioGroupNodeType & any) => {
  const [field, , helpers] = useField(name);
  const items = normalizeOptions(options);
  const hasCustomTemplate = Boolean(node?.children?.length);

  return (
      <MuiRadioGroup
          row={row ?? inline}
          sx={{
            ...(gap !== undefined ? { gap } : {}),
            ...sx,
          }}
          value={field.value || ""}
          onChange={(e) => {
            helpers.setValue(e.target.value);
          }}
      >
        {items.map((opt, index) => {
          const item = { ...opt };
          const selected = field.value === opt.value;
          const itemContext = {
            ...(context || {}),
            item,
            option: item,
            index,
            isSelected: selected,
          };

          return (
            <FormControlLabel
                key={opt.value}
                value={opt.value}
                sx={itemSx}
                control={<Radio />}
                label={
                  hasCustomTemplate
                    ? renderChildren(node.children, itemContext)
                    : opt.label || opt.value
                }
                slotProps={{
                  typography: {
                    sx: labelSx,
                  },
                }}
            />
          );
        })}
      </MuiRadioGroup>
  );
}

export default RadioGroup;
